import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export const displaySimulationQuestions = [
  BudgetQuestionCodes.Q10,
];
